import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';

export const FileDropZoneSignatureProgress: React.FC = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.stat;

		return (
			<>
				<div className="in-progress__progressbar">
					<div className="in-progress__progressbar-full"></div>
					<div className="in-progress__progressbar-complete" style={{ width: "" + store.DownloadingSignPercent + "%" }}></div>
				</div>
				<div className="in-progress__percents f-14">{store.DownloadingSignPercent}%</div>
			</>
		);
	}
)